module.exports = __webpack_public_path__ + "static/7045-300w-d204aeebdc439babed5c058c864c0798.jpg";